{
  "eyebrow": "Atsiskaitymas ir mokėjimas",
  "title": "Beveik baigta.",
  "sub": "Pereikite į saugų apmokėjimą, kad pradėtumėte 30 dienų bandymą. Šiandien nieko neapmokestinsime.",
  "summary": {
    "plan": "Planas",
    "cycle": "Atsiskaitymo ciklas",
    "users": "Naudotojai",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Transporto priemonės",
    "total": "Numatoma suma / mėn.",
    "vttOn": "Įskaičiuota"
  },
  "secureNote": "Saugus apmokėjimas per Stripe · 30 dienų bandymas · Atšaukite bet kada",
  "continue": "Tęsti į Stripe",
  "submitting": "Atidaroma Stripe…",
  "canceled": {
    "title": "Mokėjimas atšauktas",
    "sub": "Jokia suma nebuvo nuskaičiuota. Bandykite dar kartą arba susisiekite, jei reikia pagalbos.",
    "retry": "Bandyti dar kartą"
  },
  "promo": {
    "toggle": "Turite nuolaidos kodą?",
    "placeholder": "Nuolaidos kodas",
    "apply": "Taikyti",
    "chip": "{{percent}}% nuolaida",
    "remove": "Pašalinti nuolaidos kodą",
    "errorGeneric": "Nepavyko patikrinti kodo. Bandykite dar kartą."
  },
  "errors": {
    "generic": "Nepavyko pradėti apmokėjimo. Bandykite dar kartą."
  },
  "totalUnavailable": "Kainoraštis nepasiekiamas. Bandykite dar kartą, kad būtų įkelti naujausi kainos."
}
